import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import ChartComponent from "../FixedReportChart";
import StackedChartComponent from "../chartComponent/MultiBarChart";

class CallInOutReport extends React.Component {
  constructor(props) {
    super(props);
    const selectedIds = props.filters.selectedIds;
    const model = reactLocalStorage.getObject(Constants.Model);
    this.userOptions = model.user.options.filter((user) => selectedIds.includes(user.value));
    // Get direction options from local storage
    this.directionOptions = reactLocalStorage.getObject(Constants.Model).call.fields.direction.options;
    this.state = {
      directionData: [],
      directionOptions: this.directionOptions,
      inApiCall: true,
      tableData: [],
      series: []
    };
  }

  componentDidMount() {
    // Fetch call direction data
    DailySalesReportAPI.getCallsInOut(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    const { tableData, series } = this.parseData(data);
    this.setState({ directionData: data, inApiCall: false, tableData, series });
  };

  handleFail = () => {
    this.setState({ inApiCall: false });
  };

  parseData = (response) => {
    //    Prepare table data
    const tableData = this.directionOptions.map((direction) => {
      const row = { direction: direction.label };
      this.userOptions.forEach((person) => {
        // Calculate the total sum for each responsible person per feedback
        const totalSum = response
          .filter(
            (item) => {
              return item.direction == direction.value &&
                item.responsible_person == person.value;
            })
          .reduce((sum, item) => sum + (item.sum || 0), 0);

        row[person.label] = totalSum;
      });
      return row;
    });

    // Prepare chart series
    const series = this.userOptions.map((person) => ({
      name: person.label,
      data: this.directionOptions.map((direction) => {
        // Calculate the total sum for each responsible person per feedback
        const totalSum = response
          .filter(
            (item) => {
              return item.direction === direction.value &&
                item.responsible_person === person.value;
            })
          .reduce((sum, item) => sum + (item.sum || 0), 0);

        return totalSum;
      }),
    }));
    return { tableData, series };

  };
  render() {
    const { directionData, directionOptions, inApiCall, tableData, series } = this.state;

    // Create a dictionary to map direction values to sums
    const directionSums = directionOptions.reduce((acc, option) => {
      acc[option.value] = 0;
      return acc;
    }, {});
    directionData.forEach(item => {
      if (directionSums.hasOwnProperty(item.direction)) {
        directionSums[item.direction] = item.sum;
      }
    });
    const totalSum = Object.values(directionSums).filter(Boolean).reduce((total, value) => total + value, 0);
    const table = (<Table bordered hover className="col-md-6">
      <thead>
        <tr>
          <th>Direction</th>
          {this.userOptions.map((person, index) => (
            <th key={index}>{person.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData.map((row, index) => (
          <tr key={index}>
            <td>{row.direction}</td>
            {this.userOptions.map((person, idx) => (
              <td key={idx}>{row[person.label]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>);;

    return (
      <ApiUiController inApiCall={inApiCall}>
        <div>
          <h2>Incoming & Outgoing Call Report</h2>
          <hr />
          <div className="row">
              {table}
   
            <div className="col-md-6">
              {/* Add Chart Component */}
              <StackedChartComponent progressOptions={this.directionOptions} progressSums={series} type={"multiBar"} />
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(CallInOutReport);
